import type { MapModel as PluginMapModel } from 'minerva-plugin-api';
import { MapModel } from '@/types/models';
import { toPluginAnnotations } from '@/services/pluginsManager/adapters/toPluginAnnotation';

export const toPluginMapModel = (model: MapModel): PluginMapModel => ({
  ...model,
  references: toPluginAnnotations(model.references),
});
